export default __webpack_public_path__ + "static/media/no-policy.e374ec47.svg";